import React, { Component } from 'react';

//css
import './Politicas.scss';

class Politicas extends Component {
    render() {
        return (
            <div style={{backgroundColor:"red"}}>
               este es el espacio de politicas 
            </div>
        );
    }
}

export default Politicas;


// WEBPACK FOOTER //
// ./src/Pages/Politicas/Politicas.jsx